import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { ShopOrderDetailComponent } from '../shop-order-detail/shop-order-detail.component';
import { OrderService, StoreResponseDto, OrdersListDto } from 'src/generated_client'
import { AuthService } from 'src/app/services/auth/auth.service'
import { MatTableDataSource } from '@angular/material/table';
import { Component, OnInit } from '@angular/core';
import { SnackBarService } from 'src/app/services/snack-bar.service';
import { GetTimeDialogComponent } from '../get-time-dialog/get-time-dialog.component';
import { RejectionMessagesComponent } from '../rejection-messages/rejection-messages.component';
import { SignalRService } from 'src/app/services/signal-r.service';

@Component({
  selector: 'app-active-shop-orders',
  templateUrl: './active-shop-orders.component.html',
  styleUrls: ['./active-shop-orders.component.css']
})

export class ActiveShopOrdersComponent implements OnInit {

  private currentStore: StoreResponseDto = {};
  private hubConnection!: signalR.HubConnection;

  orderList: OrdersListDto[] = [];
  dataSource = new MatTableDataSource();

  constructor(
    private dialog: MatDialog,
    private router: Router,
    private orderService: OrderService,
    private authService: AuthService,
    private snack: SnackBarService,
    private _signalRService: SignalRService
  ) { }

  displayedColumns: string[] = ['id', 'comercio', 'usuario', 'direccion', 'items', 'status', 'opciones'];

  ngOnInit(): void {

    this.router.routeReuseStrategy.shouldReuseRoute = () => false;

    this.currentStore = this.authService.currentUserStore();

    this.dataSource.filterPredicate = function (data: any, filter: string): boolean {
      return data.cdOrder.toString().includes(filter)
    };

    this.getActiveOrders();

    this.initializeSingalR();
  }

  async ngOnDestroy(): Promise<void> {
    await this.closeSignalR();
  }

  public applyFilter(event: Event) {

    const filterValue = (event.target as HTMLInputElement).value;

    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  public openOrder(idOrder: number) {

    let order = this.orderList.find(x => x.cdOrder == idOrder);

    let items = order?.itemInOrderOutputDtos;

    this.dialog.open(ShopOrderDetailComponent, {
      data: {
        items: items,
        delivery: order?.qtDCharges,
        discount: order?.qtDiscount,
        discountItemValue: order?.qtItemsDiscountedTotal,
        total: order?.qtTotal,
        notes: order?.dsNotes
      }
    });
  }

  public editOrder() {
    this.router.navigate(['edit-active-order', 1]);
  }

  public AceptOrder(idOrder: number) {

    this.dialog.open(GetTimeDialogComponent, {
      data: {
        message: 'Seleccione el tiempo de preparación del pedido'
      }
    }).afterClosed().subscribe(x => {

      if (x) {
        this.orderService.apiOrderConfirmOrderPut(idOrder, x).subscribe(() => {
          this.snack.openSnackBar("Orden Aceptada", "Aceptar");
          this.refresh();
        },
          err => {
            if (err.error.error)
              this.snack.openSnackBar(err.error.error, "Aceptar")
            else
              this.snack.openSnackBar("Ocurrio un problema, intente mas tarde", "Aceptar");
          }
        );
      }
    });
  };

  public CancelRejectOrder(idOrder: number, nmStatus: number) {

    if (nmStatus == 0)
      this.rejectOrder(idOrder);
    // else
    //   this.cancelOrder(idOrder);
  };

  public ConfirmOrder(id: number) {

    this.orderService.apiOrderConfirmDeliverPut(id).subscribe(() => {
      this.router.navigate(['active-shop-orders']);
    },
      err => {
        this.snack.openSnackBar("Se produjeron errores al modificar orden", 'Aceptar');
      });
  }

  OnTheWay(id: number) {

    this.orderService.apiOrderOnTheWayPut(id).subscribe(() => {
      this.router.navigate(['active-shop-orders']);
    },
      err => {
        this.snack.openSnackBar("Se produjeron errores al modificar orden", 'Aceptar');
      }
    );
  }

  private refresh() {
    this.router.navigate(['active-shop-orders']);
  }

  private getActiveOrders() {

    this.orderService.apiOrderGetAllAcceptedByStoreGet(this.currentStore.cdStore).subscribe(x => {

      this.orderList = x.sort((a, b) => (b.dtOrderDate! > a.dtOrderDate!) ? 1 : -1);
      this.dataSource.data = this.orderList

    },
      err => {
        this.snack.openSnackBar("Se produjeron errores al intentar obtener ordenes", "Aceptar");
      }
    )
  };

  private initializeSingalR() {

    this._signalRService.startConnection();
    this._signalRService.addToGroupWithStart(String(this.currentStore.cdStore));

    this.hubConnection = this._signalRService.getHubConnection();

    this.hubConnection.on("UpdateOrdersInStore", () => this.getActiveOrders());
  }

  private async closeSignalR() {
    await this.hubConnection.stop();
  }

  // private cancelOrder(idOrder: number) {
  //   this.orderService.apiOrderCancelOrderPut(idOrder).subscribe(() => {
  //     this.snack.open("Orden Cancelada", "Aceptar");
  //     this.refresh();
  //   },
  //     err => {
  //       this.snack.open(err.error.error, 'Aceptar');
  //     }
  //   );
  // }


  private rejectOrder(idOrder: number) {

    this.dialog.open(RejectionMessagesComponent, {
      data: {
        message: 'Elija un mensaje:'
      }
    }).afterClosed().subscribe((message?: string) => {

      if (message) {
        this.orderService.apiOrderRejectOrderPut(idOrder, message).subscribe(() => {
          this.snack.openSnackBar("Pedido rechazado", "Aceptar");
          this.refresh();
        },
          err => {
            console.log(err);
            if (err.error.error) {
              this.snack.openSnackBar(err.error.error, 'Aceptar');
            } else
              this.snack.openSnackBar("Ocurrió un problema, intente más tarde", "Aceptar");
          }
        );
      }
    })
  }

  openDialog() {
    const dialogRef = this.dialog.open(RejectionMessagesComponent, { restoreFocus: false });
  }

}
